import { ConfigStoreClass } from './DataSource/Stores/ConfigStore';

const config = new ConfigStoreClass();

export { config };
